import React from 'react';
import { Card, Col, Badge, ProgressBar } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const SubscriptionInfo: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  // Mock subscription data for now - will be replaced with real data later
  const mockSubscription = {
    tier: 'Professional',
    status: 'Active',
    renewalDate: '2025-08-24',
    monthlySearches: 1000,
    usedSearches: 247,
    features: ['Unlimited Phone Number Searches', 'Advanced Filters', 'Export Results', 'API Access']
  };

  const getStatusBadgeClass = (status: string) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'bg-success';
      case 'cancelled':
        return 'bg-danger';
      case 'pending':
        return 'bg-warning';
      default:
        return 'bg-secondary';
    }
  };

  const calculateUsagePercentage = () => {
    return Math.round((mockSubscription.usedSearches / mockSubscription.monthlySearches) * 100);
  };

  return (
    <Col xs={12} className="mb-0 mb-md-0 d-flex align-items-stretch">
      <Card className="h-100 shadow-sm w-100 dashboard-card">
        <Card.Body className="d-flex flex-column justify-content-between p-4 text-start">
          <Card.Title className="fw-bold mb-3">Subscription</Card.Title>
          <div className="mb-2">
            <span className="fw-semibold">Status:</span>{' '}
            <Badge className={getStatusBadgeClass(mockSubscription.status)}>{mockSubscription.status}</Badge>
          </div>
          <div className="mb-2">
            <span className="fw-semibold">Tier:</span>{' '}
            <Badge bg="info">{mockSubscription.tier}</Badge>
          </div>
          <div className="mb-2">
            <span className="fw-semibold">Renewal:</span>{' '}
            {new Date(mockSubscription.renewalDate).toLocaleDateString()}
          </div>
          <div className="mb-2">
            <span className="fw-semibold">Usage:</span>{' '}
            {mockSubscription.usedSearches} / {mockSubscription.monthlySearches} ({calculateUsagePercentage()}%)
            <ProgressBar now={calculateUsagePercentage()} label={`${calculateUsagePercentage()}%`} className="mt-1" />
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
//
};

export default SubscriptionInfo;
